<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <!-- onclick="outerbody();" -->
        <div class="row">
            <div class="col-10">
                <h4 class="fs-title">REGISTRATION DETAIL REQUEST {{schoolname}}</h4>
            </div>
        </div>
        <div class="row card">
            <div class="col-lg-12">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #RegistrationForm="ngForm" id="RegistrationForm" class="msform">
                            <div class="row mt-2" style="display: none;">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>University</b><span class="text-danger">*</span></label> <br>
                                    <label *ngFor="let b of boards; let i=index">
                                        <input type="checkbox" id="chkBoard{{i}}" name="chkBoard{{i}}" />
                                        &nbsp;&nbsp; {{b.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Medium</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let m of mediums; let i=index">
                                        <input type="checkbox" id="chkmedium{{i}}" name="chkmedium{{i}}"
                                            (change)="fillCourse()" />
                                        &nbsp;&nbsp; {{m.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Institute Type</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let ins of institutetypes; let i=index">
                                        <input type="checkbox" id="chkinstitute{{i}}" name="chkinstitute{{i}}" [value]="ins.value"
                                            (change)="fillCourse()" />
                                        &nbsp;&nbsp; {{ins.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Faculty</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of sections; let i=index">
                                        <input type="checkbox" id="chksection{{i}}" name="chksection{{i}}"
                                            (change)="fillCourse()" />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>University</b><span class="text-danger">*</span></label> <br>
                                    <label *ngFor="let b of boards; let i=index">
                                        <input type="checkbox" id="oldchkBoard{{i}}" name="oldchkBoard{{i}}" />
                                        &nbsp;&nbsp; {{b.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Medium</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let m of mediums; let i=index">
                                        <input type="checkbox" id="oldchkmedium{{i}}" name="oldchkmedium{{i}}"
                                            (change)="fillOldCourse()" />
                                        &nbsp;&nbsp; {{m.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Institute Type</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let ins of institutetypes; let i=index">
                                        <input type="checkbox" id="oldchkinstitute{{i}}" name="oldchkinstitute{{i}}" [value]="ins.value"
                                            (change)="fillOldCourse()" />
                                        &nbsp;&nbsp; {{ins.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Faculty</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of sections; let i=index">
                                        <input type="checkbox" id="oldchksection{{i}}" name="oldchksection{{i}}"
                                            (change)="fillOldCourse()" />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                            </div>
                            <div class="row mt-2" style="display: none;" *ngIf="standards != undefined && standards.length > 0">
                                <div class="form-group col-lg-10 col-md-12 col-12">
                                    <label><b>Course</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of standards; let i=index">
                                        <input type="checkbox" id="chkStd{{i}}" name="chkStd{{i}}"
                                            (change)="manageRegDoc(i,s.text,s.MediumID,s.sectionID,s.value);" checked />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                            </div>
                            <div class="row mt-2" style="display: none;" *ngIf="oldstandards != undefined && oldstandards.length > 0">
                                <div class="form-group col-lg-10 col-md-12 col-12">
                                    <label><b>Course</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of standards; let i=index">
                                        <input type="checkbox" id="oldchkStd{{i}}" name="oldchkStd{{i}}"
                                        (change)="manageOldRegDoc(i,s.text,s.MediumID,s.sectionID,s.value);"  checked />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                            </div>
                    
                    <div class="border border-dark  bg-custom  p-2">
                        <h4>Trustee Details</h4>
                        <hr style="margin: 0;">
                        <!-- <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_trusteeDetailID">
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Trustee's name</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeName="ngModel" ngModel
                                            name="TrusteeName" [(ngModel)]="data.TrusteeName" maxlength="200"
                                            placeholder="Enter trustee's name">
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Trustee Address</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeAddress="ngModel" ngModel
                                            name="TrusteeAddress" [(ngModel)]="data.TrusteeAddress" maxlength="300"
                                            (keypress)="blockSpecialChar($event)" placeholder="Enter trustee address">
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Contact / Mobile no.</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeMobileNo="ngModel" ngModel
                                            name="TrusteeMobileNo" [(ngModel)]="data.TrusteeMobileNo" minlength="10"
                                            maxlength="10" placeholder="Enter Contact / Mobile no." numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Trustee's mail id</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeMailID="ngModel" ngModel
                                            name="TrusteeMailID" [(ngModel)]="data.TrusteeMailID" maxlength="50"
                                            placeholder="Enter trustee's mail id"
                                            pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$">
                                    </div>
                                </div> -->
                        <!-- <div class="row  mt-2">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addTrustee()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearTrustee()">Clear</button>
                                    </div>
                                </div> -->
                        <div class="form-group row mt-4">
                            <div class="col-lg-6 col-md-6 col-6">
                                <h5 style="color:green">Existing Data</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Trustee's name</th>
                                                <th>Trustee's address</th>
                                                <th>Trustee's Contact / Mobile no.</th>
                                                <th>Trustee's mail id</th>
                                                <!-- <th>ACTION</th> -->
                                            </tr>
                                        </thead>
                                        <tr *ngFor="let t of OldTrusteeDetail;let i = index">
                                            <td>{{t.TrusteeName}}</td>
                                            <td>{{t.TrusteeAddress}}</td>
                                            <td>{{t.TrusteeMobileNo}}</td>
                                            <td>{{t.TrusteeMailID}}</td>
                                            <!-- <td style="white-space: nowrap;">
                                                        <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                            (click)="editTrustee(i)">Edit</button>
                                                        &nbsp; <button type="button"
                                                            class="btn btn-danger mt-0 d-inline"
                                                            (click)="deleteTrustee(i)">Delete</button>
                                                    </td> -->
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <hr>
                            <div class="col-lg-6 col-md-6 col-6">
                                <h5 style="color:#e03636">Requested Data</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Trustee's name</th>
                                                <th>Trustee's address</th>
                                                <th>Trustee's Contact / Mobile no.</th>
                                                <th>Trustee's mail id</th>
                                                <!-- <th>ACTION</th> -->
                                            </tr>
                                        </thead>
                                        <tr *ngFor="let t of TrusteeDetail;let i = index">
                                            <td>{{t.TrusteeName}}</td>
                                            <td>{{t.TrusteeAddress}}</td>
                                            <td>{{t.TrusteeMobileNo}}</td>
                                            <td>{{t.TrusteeMailID}}</td>
                                            <!-- <td style="white-space: nowrap;">
                                                        <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                            (click)="editTrustee(i)">Edit</button>
                                                        &nbsp; <button type="button"
                                                            class="btn btn-danger mt-0 d-inline"
                                                            (click)="deleteTrustee(i)">Delete</button>
                                                    </td> -->
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_InfrastructureDetailID">
                                    <div class="form-group col-lg-3 col-md-12 col-12">
                                        <label><b>Infrastructure Type</b><span class="text-danger">*</span></label>
                                        <select class="form-control" #InfrastructureID="ngModel" ngModel
                                            name="InfrastructureID" [(ngModel)]="data.InfrastructureID" required>
                                            <option *ngFor="let inf of infrastructures" [value]="inf.value"
                                                [selected]="data.InfrastructureID == inf.value">
                                                {{ inf.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>No. of infrastructure</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #NoOfInfrastructure="ngModel" ngModel
                                            name="NoOfInfrastructure" [(ngModel)]="data.NoOfInfrastructure"
                                            maxlength="10" placeholder="Enter no. of infrastructure" numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Infrastructure size (in Sq.Ft.)</b><span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #InfrastructureSize="ngModel" ngModel
                                            name="InfrastructureSize" [(ngModel)]="data.InfrastructureSize"
                                            maxlength="10" placeholder="Enter infrastructure size" numbersOnly>
                                    </div>
                                </div> -->
                    <!-- <div class="row  mt-2">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addInfrastructure()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearInfrastructure()">Clear</button>
                                    </div>
                                </div> -->

                    <!-- <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editInfrastructure(i)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteInfrastructure(i)">Delete</button>
                                                </td> -->
                    <!-- <div class="border border-dark  bg-custom  p-2 mt-2">
                                <h4>Infrastructure Details</h4>
                                <hr style="margin: 0;">
                                <div class="form-group row mt-4">
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:green">Existing Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Infrastructure type</th>
                                                        <th>No. of infrastructure</th>
                                                        <th>Infrastructure size</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of OldInfrastructureDetail;let i = index">
                                                    <td>{{t.InfrastructureType}}</td>
                                                    <td>{{t.NoOfInfrastructure}}</td>
                                                    <td>{{t.InfrastructureSize}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:#e03636">Requested Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Infrastructure type</th>
                                                        <th>No. of infrastructure</th>
                                                        <th>Infrastructure size</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of InfrastructureDetail;let i = index">
                                                    <td>{{t.InfrastructureType}}</td>
                                                    <td>{{t.NoOfInfrastructure}}</td>
                                                    <td>{{t.InfrastructureSize}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                    <div class="border border-dark  bg-custom  p-2 mt-2">
                        <h4>Employee Details</h4>
                        <hr style="margin: 0;">
                        <!-- <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_EmployeeDetailID">
                                    <div class="form-group col-lg-4 col-md-12 col-12">
                                        <label><b>Employee type</b><span class="text-danger">*</span></label>
                                        <select class="form-control" #EmployeeTypeID="ngModel" ngModel
                                            name="EmployeeTypeID" [(ngModel)]="data.EmployeeTypeID" required>
                                            <option *ngFor="let inf of employeetypes" [value]="inf.value"
                                                [selected]="data.EmployeeTypeID == inf.value">
                                                {{ inf.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>No. of permanent employee</b></label>
                                        <input type="text" class="form-control" #NoOfPermanentEmployee="ngModel" ngModel
                                            name="NoOfPermanentEmployee" [(ngModel)]="data.NoOfPermanentEmployee"
                                            maxlength="10" placeholder="Enter no. of permanent employee" numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>No. of adhoc employee</b></label>
                                        <input type="text" class="form-control" #NoOfAdhocEmployee="ngModel" ngModel
                                            name="NoOfAdhocEmployee" [(ngModel)]="data.NoOfAdhocEmployee" maxlength="10"
                                            placeholder="Enter no. of adhoc employee" numbersOnly>
                                    </div>
                                </div>
                                <div class="row mt-2 " style="margin: 2px;">
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Total permanent employee's salary</b></label>
                                        <input type="text" class="form-control" #TotalPermanentSalary="ngModel" ngModel
                                            name="TotalPermanentSalary" [(ngModel)]="data.TotalPermanentSalary"
                                            maxlength="10" placeholder="Enter total permanent employee's salary"
                                            numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Total adhoc employee's salary</b></label>
                                        <input type="text" class="form-control" #TotalAdhocSalary="ngModel" ngModel
                                            name="TotalAdhocSalary" [(ngModel)]="data.TotalAdhocSalary" maxlength="10"
                                            placeholder="Enter total adhoc employee's salary" numbersOnly>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addEmployeeDetail()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearEmployeeDetail()">Clear</button>
                                    </div>
                                </div> -->
                        <div class="form-group row mt-4">
                            <div class="col-lg-6 col-md-6 col-6">
                                <h5 style="color:green">Existing Data</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered table-responsive">
                                        <thead>
                                            <tr>
                                                <th>Employee type</th>
                                                <th>No. of permanent employee</th>
                                                <th>No. of Ad-Hoc employee</th>
                                                <th>Total permanent employee's salary</th>
                                                <th>Total Ad-Hoc employee's salary</th>
                                                <!-- <th>Action</th> -->
                                            </tr>
                                        </thead>
                                        <tr *ngFor="let t of OldEmployeeDetail;let i = index">
                                            <td>{{t.EmployeeType}}</td>
                                            <td>{{t.NoOfPermanentEmployee}}</td>
                                            <td>{{t.NoOfAdhocEmployee}}</td>
                                            <td>{{t.TotalPermanentSalary}}</td>
                                            <td>{{t.TotalAdhocSalary}}</td>
                                            <!-- <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editEmployeeDetail(i)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteEmployeeDetail(i)">Delete</button>
                                                </td> -->
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-6">
                                <h5 style="color:#e03636">Requested Data</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Employee type</th>
                                                <th>No. of permanent employee</th>
                                                <th>No. of Ad-Hoc employee</th>
                                                <th>Total permanent employee's salary</th>
                                                <th>Total Ad-Hoc employee's salary</th>
                                            </tr>
                                        </thead>
                                        <tr *ngFor="let t of EmployeeDetail;let i = index">
                                            <td>{{t.EmployeeType}}</td>
                                            <td>{{t.NoOfPermanentEmployee}}</td>
                                            <td>{{t.NoOfAdhocEmployee}}</td>
                                            <td>{{t.TotalPermanentSalary}}</td>
                                            <td>{{t.TotalAdhocSalary}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="border border-dark  bg-custom  p-2 mt-2">
                        <h4>Employee Qualification Details</h4>
                        <hr style="margin: 0;">
                        <!-- <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_EmployeeQualificationDetailID">
                                    <div class="form-group col-lg-4 col-md-12 col-12">
                                        <label><b>Qualification type</b><span class="text-danger">*</span></label>
                                        <select class="form-control" #EmployeeQualificationTypeID="ngModel" ngModel
                                            name="EmployeeQualificationTypeID" [(ngModel)]="data.QualificationID"
                                            required>
                                            <option *ngFor="let inf of qualifications" [value]="inf.value"
                                                [selected]="data.QualificationID == inf.value">
                                                {{ inf.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>No. of employees</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #NoOfEmployee="ngModel" ngModel
                                            name="NoOfEmployee" [(ngModel)]="data.NoofEmployee" maxlength="10"
                                            placeholder="Enter no. of employee" numbersOnly>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addEmployeeQualification()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearEmployeeQualification()">Clear</button>
                                    </div>
                                </div> -->
                        <div class="form-group row mt-4">
                            <div class="col-lg-6 col-md-6 col-6">
                                <h5 style="color:green">Existing Data</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Qualification type</th>
                                                <th>No. of employees</th>
                                                <!-- <th>Action</th> -->
                                            </tr>
                                        </thead>
                                        <tr *ngFor="let t of OldEmployeeQualificationDetail;let i = index">
                                            <td>{{t.Qualification}}</td>
                                            <td>{{t.NoofEmployee}}</td>
                                            <!-- <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editEmployeeQualification(i)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteEmployeeQualification(i)">Delete</button>
                                                </td> -->
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-6">
                                <h5 style="color:#e03636">Requested Data</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Qualification type</th>
                                                <th>No. of employees</th>
                                            </tr>
                                        </thead>
                                        <tr *ngFor="let t of EmployeeQualificationDetail;let i = index">
                                            <td>{{t.Qualification}}</td>
                                            <td>{{t.NoofEmployee}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="border border-dark bg-custom p-2 mt-2">
                        <!-- <div class="row mt-2" style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_principalDetailID">
                                    <div class="form-group col-lg-3 col-md-12 col-12">
                                        <label><b>Designation</b><span class="text-danger">*</span></label>
                                        <select class="form-control" #DesignationID="ngModel" ngModel
                                            name="DesignationID" [(ngModel)]="data.DesignationID" required>
                                            <option *ngFor="let des of designations" [value]="des.value"
                                                [selected]="data.DesignationID == des.value">
                                                {{ des.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>College's principal name</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #PrincipalName="ngModel" ngModel
                                            name="PrincipalName" [(ngModel)]="data.PrincipalName" maxlength="200"
                                            placeholder="Enter college's principal name">
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>CONTACT / MOBILE NO.</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #PrincipalMobileNo="ngModel" ngModel
                                            name="PrincipalMobileNo" [(ngModel)]="data.PrincipalMobileNo" minlength="10"
                                            maxlength="10" numbersOnly placeholder="Enter contact / mobile no.">
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>PRINCIPAL'S MAIL ID</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #PrincipalMailID="ngModel" ngModel
                                            name="PrincipalMailID" [(ngModel)]="data.PrincipalMailID" maxlength="50"
                                            placeholder="Enter principal's mail id"
                                            pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$">
                                    </div>
                                </div> -->
                        <!-- <div class="row  mt-2">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addPrincipal()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearPrincipal()">Clear</button>
                                    </div>
                                </div> -->
                        <h4>Principal Details</h4>
                        <hr style="margin: 0;">
                        <div class="form-group row mt-4">
                            <div class="col-lg-6 col-md-6 col-6">
                                <h5 style="color:green">Existing Data</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Designation</th>
                                                <th>Principal's name</th>
                                                <th>Principal's mobile no.</th>
                                                <th>Principal's mail id</th>
                                                <!-- <th>Action</th> -->
                                            </tr>
                                        </thead>
                                        <tr *ngFor="let t of OldPrincipalDetail;let j = index">
                                            <td>{{t.PrinDesignation}}</td>
                                            <td>{{t.PrincipalName}}</td>
                                            <td>{{t.PrincipalMobileNo}}</td>
                                            <td>{{t.PrincipalMailID}}</td>
                                            <!-- <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editPrincipal(j)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deletePrincipal(j)">Delete</button>
                                                </td> -->
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-6">
                                <h5 style="color:#e03636">Requested Data</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Designation</th>
                                                <th>Principal's name</th>
                                                <th>Principal's mobile no.</th>
                                                <th>Principal's mail id</th>
                                            </tr>
                                        </thead>
                                        <tr *ngFor="let t of PrincipalDetail;let j = index">
                                            <td>{{t.PrinDesignation}}</td>
                                            <td>{{t.PrincipalName}}</td>
                                            <td>{{t.PrincipalMobileNo}}</td>
                                            <td>{{t.PrincipalMailID}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <!-- <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Name of authorized person who remained present in submitted
                                            affidevit</b>
                                        <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #AuthorizedPerson="ngModel" ngModel
                                        name="AuthorizedPerson" [(ngModel)]="data.AuthorizedPerson" maxlength="50"
                                        placeholder="Enter name of authorized person" required>
                                    <span *ngIf="RegistrationForm.submitted && AuthorizedPerson.invalid">
                                        <p *ngIf="AuthorizedPerson.errors.required" class="error_message"
                                            style="color: red;">
                                            Name of authorized person is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Designation</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #Designation="ngModel" ngModel
                                        name="Designation" [(ngModel)]="data.Designation" maxlength="50"
                                        placeholder="Enter designation" required>
                                    <span *ngIf="RegistrationForm.submitted && Designation.invalid">
                                        <p *ngIf="Designation.errors.required" class="error_message"
                                            style="color: red;">
                                            Designation is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Contact / mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #MobileNo="ngModel" ngModel name="MobileNo"
                                        [(ngModel)]="data.MobileNo" numbersOnly placeholder="Enter contact / mobile no."
                                        minlength="10" maxlength="10" required>
                                    <span *ngIf="RegistrationForm.submitted && MobileNo.invalid">
                                        <p *ngIf="MobileNo.errors.required" class="error_message" style="color: red;">
                                            Contact / mobile no. is required
                                        </p>
                                        <p *ngIf="MobileNo.errors.minlength" class="error_message" style="color: red;">
                                            Contact / mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="MobileNo.errors.maxlength" class="error_message" style="color: red;">
                                            Contact / mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div> -->
                        <div class="col-lg-6 col-md-6 col-6">
                            <h5 style="color:green">Existing Data</h5>
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Name of authorized person who remained present in submitted
                                                affidevit</th>
                                            <th>Designation</th>
                                            <th>Contact / mobile no.</th>
                                            <th>Whatsapp mobile no.</th>
                                        </tr>
                                    </thead>
                                    <tr>
                                        <td>{{data.OldAuthorizedPerson}}</td>
                                        <td>{{data.OldDesignation}}</td>
                                        <td>{{data.OldMobileNo}}</td>
                                        <td>{{data.OldWhatsAppNo}}</td>

                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-6">
                            <h5 style="color:#e03636">Requested Data</h5>
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Name of authorized person who remained present in submitted
                                                affidevit</th>
                                            <th>Designation</th>
                                            <th>Contact / mobile no.</th>
                                            <th>Whatsapp mobile no.</th>
                                        </tr>
                                    </thead>
                                    <tr>
                                        <td>{{data.AuthorizedPerson}}</td>
                                        <td>{{data.Designation}}</td>
                                        <td>{{data.MobileNo}}</td>
                                        <td>{{data.WhatsAppNo}}</td>

                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Whatsapp mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #WhatsAppNo="ngModel" ngModel
                                        name="WhatsAppNo" [(ngModel)]="data.WhatsAppNo" numbersOnly
                                        placeholder="Enter whatsapp contact / mobile no." minlength="10" maxlength="10"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && WhatsAppNo.invalid">
                                        <p *ngIf="WhatsAppNo.errors.required" class="error_message" style="color: red;">
                                            Whatsapp mobile no. is required
                                        </p>
                                        <p *ngIf="WhatsAppNo.errors.minlength" class="error_message"
                                            style="color: red;">
                                            Whatsapp mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="WhatsAppNo.errors.maxlength" class="error_message"
                                            style="color: red;">
                                            Whatsapp mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>
                            </div> -->
                    <div class="border border-dark bg-custom p-2 mt-2">
                        <div class="form-group row mt-4">
                            <div class="col-lg-6 col-md-6 col-6">
                                <h5 style="color:green">Existing Data</h5>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Course (Year)</th>
                                            <th>Divison - Student Count</th>
                                        </tr>
                                    </thead>

                                    <tr *ngFor="let s of OldstandardList; let i=index">
                                        <td>
                                            <label><b>{{s.text}}</b>
                                            </label>
                                            <input type="hidden" class="form-control" ngModel name="oldstd{{i}}_{{i}}"
                                                id="oldstd{{i}}_{{i}}" numbersOnly maxlength="2"
                                                placeholder="Enter no. of division"
                                                (keyup)="oldfillDiv(s.value,i,s.year)">
                                        </td>
                                        <td id="olddivlist{{s.value}}_{{i}}_{{s.year}}">

                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-lg-6 col-md-6 col-6">
                                <h5 style="color:#e03636">Requested Data</h5>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Course (Year)</th>
                                            <th>Divison - Student Count</th>
                                        </tr>
                                    </thead>

                                    <tr *ngFor="let s of standardList; let i=index">
                                        <td>
                                            <label><b>{{s.text}}</b>
                                            </label>
                                            <input type="hidden" class="form-control" ngModel name="std{{i}}_{{i}}"
                                                id="std{{i}}_{{i}}" numbersOnly maxlength="2"
                                                placeholder="Enter no. of division" (keyup)="fillDiv(s.value,i,s.year)">
                                        </td>
                                        <td id="divlist{{s.value}}_{{i}}_{{s.year}}">

                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </div>
                    </div>

                    <!-- <div class="row mt-2" style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_ownerDetailID">
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Land owner name</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #OwnerName="ngModel" ngModel
                                            name="OwnerName" [(ngModel)]="data.OwnerName" maxlength="200"
                                            placeholder="Enter land owner name">
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Owner's contact / mobile no.</b><span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #OwnerMobileNo="ngModel" ngModel
                                            name="OwnerMobileNo" [(ngModel)]="data.OwnerMobileNo" minlength="10"
                                            maxlength="10" numbersOnly placeholder="Enter owner contact / mobile no.">
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Owner's mail id</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #OwnerMailID="ngModel" ngModel
                                            name="OwnerMailID" [(ngModel)]="data.OwnerMailID" maxlength="50"
                                            placeholder="Enter owner's mail id"
                                            pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$">
                                    </div>
                                </div>
                                <div class="row  mt-2">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addOwner()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearOwner()">Clear</button>
                                    </div>
                                </div> -->
                    <!-- <div class="border border-dark bg-custom p-2 mt-2">
                                    <h4>Land Owner Details</h4>
                                    <hr style="margin: 0;">
                                <div class="form-group row mt-4">
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:green">Existing Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Owner's name</th>
                                                        <th>Owner's mobile no</th>
                                                        <th>Owner's mail id</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let o of OldOwnerDetail;let j = index">
                                                    <td>{{o.OwnerName}}</td>
                                                    <td>{{o.OwnerMobileNo}}</td>
                                                    <td>{{o.OwnerMailID}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:#e03636">Requested Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Owner's name</th>
                                                        <th>Owner's mobile no</th>
                                                        <th>Owner's mail id</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let o of OwnerDetail;let j = index">
                                                    <td>{{o.OwnerName}}</td>
                                                    <td>{{o.OwnerMobileNo}}</td>
                                                    <td>{{o.OwnerMailID}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                    <!-- <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Amount</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #PendingSalaryIncrementAmount="ngModel"
                                            ngModel name="PendingSalaryIncrementAmount"
                                            [(ngModel)]="data.PendingSalaryIncrementAmount" maxlength="20"
                                            (keypress)="onlyDouble($event,data.PendingSalaryIncrementAmount)"
                                            placeholder="Enter amount" required>
                                        <span
                                            *ngIf="RegistrationForm.submitted && PendingSalaryIncrementAmount.invalid">
                                            <p *ngIf="PendingSalaryIncrementAmount.errors.required"
                                                class="error_message" style="color: red;">
                                                Amount is required
                                            </p>
                                        </span>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Description</b><span class="text-danger">*</span></label>
                                        <textarea class="form-control" #PendingSalaryIncrementDescription="ngModel"
                                            ngModel name="PendingSalaryIncrementDescription" rows="3" maxlength="200"
                                            style="height: 60px;"
                                            [(ngModel)]="data.PendingSalaryIncrementDescription"></textarea>
                                    </div> -->
                    <!-- <div class="border border-dark bg-custom p-2 mt-2">
                                <h4>Pending salary increment</h4>
                                <hr style="margin: 0;">
                                <div class="row mt-2" style="margin: 2px;">
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:green">Existing Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Amount</th>
                                                        <th>Description</th>
                                                    </tr>
                                                </thead>
                                                <tr>
                                                    <td>{{data.OldPendingSalaryIncrementAmount}}</td>
                                                    <td>{{data.OldPendingSalaryIncrementDescription}}</td>

                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:#e03636">Requested Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Amount</th>
                                                        <th>Description</th>
                                                    </tr>
                                                </thead>
                                                <tr>
                                                    <td>{{data.PendingSalaryIncrementAmount}}</td>
                                                    <td>{{data.PendingSalaryIncrementDescription}}</td>

                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                    <!-- <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Amount</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #DepreciationAmount="ngModel" ngModel
                                            name="DepreciationAmount" [(ngModel)]="data.DepreciationAmount"
                                            maxlength="20" (keypress)="onlyDouble($event,data.DepreciationAmount)"
                                            placeholder="Enter amount" required>
                                        <span *ngIf="RegistrationForm.submitted && DepreciationAmount.invalid">
                                            <p *ngIf="DepreciationAmount.errors.required" class="error_message"
                                                style="color: red;">
                                                Amount is required
                                            </p>
                                            <p *ngIf="data.DepreciationAmount <= 0" class="error_message"
                                                style="color: red;">
                                                Amount must be greater then zero
                                            </p>
                                        </span>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Description</b><span class="text-danger">*</span></label>
                                        <textarea class="form-control" #DepreciationDescription="ngModel" ngModel
                                            name="DepreciationDescription" rows="3" maxlength="200"
                                            style="height: 60px;" [(ngModel)]="data.DepreciationDescription"></textarea>
                                    </div> -->
                    <!-- <br>
                            <div class="border border-dark bg-custom p-2 mt-2">
                                <h4>Depreciation</h4>
                                <div class="row mt-2" style="margin: 2px;">
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:green">Existing Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Amount</th>
                                                        <th>Description</th>
                                                    </tr>
                                                </thead>
                                                <tr>
                                                    <td>{{data.OldDepreciationAmount}}</td>
                                                    <td>{{data.OldDepreciationDescription}}</td>

                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:#e03636">Requested Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Amount</th>
                                                        <th>Description</th>
                                                    </tr>
                                                </thead>
                                                <tr>
                                                    <td>{{data.DepreciationAmount}}</td>
                                                    <td>{{data.DepreciationDescription}}</td>

                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                    <!-- <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Total available classrooms</b><span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #NoOfClassroom="ngModel" ngModel
                                            name="NoOfClassroom" [(ngModel)]="data.NoOfClassroom" maxlength="20"
                                            (keyup)="fillClassRooms()" numbersOnly
                                            placeholder="Enter total available Classrooms" required>
                                        <span *ngIf="RegistrationForm.submitted && NoOfClassroom.invalid">
                                            <p *ngIf="NoOfClassroom.errors.required" class="error_message"
                                                style="color: red;">
                                                Total available classrooms is required
                                            </p>
                                        </span>
                                    </div> -->
                    <!-- <div class="border border-dark bg-custom p-2 mt-2">
                                <div class="form-group row mt-4">
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:green">Existing Data</h5>
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Total available classrooms</th>
                                                    <th>Classroom name - Classroom size (Format : Length x Width)</th>
                                                </tr>
                                            </thead>

                                            <tr>
                                                <td>
                                                    <label><b>{{data.OldNoOfClassroom}}</b>
                                                    </label>

                                                </td>
                                                <td id="divOldClassRoom">

                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:#e03636">Requested Data</h5>
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Total available classrooms</th>
                                                    <th>Classroom name - Classroom size (Format : Length x Width)</th>
                                                </tr>
                                            </thead>

                                            <tr>
                                                <td>
                                                    <label><b>{{data.NoOfClassroom}}</b>
                                                    </label>

                                                </td>
                                                <td id="divClassRoom">

                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div> -->

                    <!-- <div id="divClassRoom" style="width: 100%;">

                                </div> -->


                    <!-- <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Land area in square feet</b>
                                        <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #LandArea="ngModel" ngModel name="LandArea"
                                        [(ngModel)]="data.LandArea" maxlength="50"
                                        (keypress)="onlyDouble($event,data.LandArea)"
                                        placeholder="Enter land area in square feet" required>
                                    <span *ngIf="RegistrationForm.submitted && LandArea.invalid">
                                        <p *ngIf="LandArea.errors.required" class="error_message" style="color: red;">
                                            Land area in square feet is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Land construction group and total both</b>
                                        <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #LandConstruction="ngModel" ngModel
                                        name="LandConstruction" [(ngModel)]="data.LandConstruction" maxlength="50"
                                        (keypress)="onlyDouble($event,data.LandConstruction)"
                                        placeholder="Enter land area in square feet" required>
                                    <span *ngIf="RegistrationForm.submitted && LandConstruction.invalid">
                                        <p *ngIf="LandConstruction.errors.required" class="error_message"
                                            style="color: red;">
                                            Land construction group and total both is required
                                        </p>
                                    </span>
                                </div> -->
                    <!-- <div class="row mt-2">
                                <div class="col-lg-6 col-md-6 col-6">
                                    <h5 style="color:green">Existing Data</h5>
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Land area in square feet</th>
                                                    <th>Land construction group and total both</th>
                                                </tr>
                                            </thead>
                                            <tr>
                                                <td>{{data.OldLandArea}}</td>
                                                <td>{{data.OldLandConstruction}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-6">
                                    <h5 style="color:#e03636">Requested Data</h5>
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Land area in square feet</th>
                                                    <th>Land construction group and total both</th>
                                                </tr>
                                            </thead>
                                            <tr>
                                                <td>{{data.LandArea}}</td>
                                                <td>{{data.LandConstruction}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div> -->
                    <div class="row mt-2">
                        <div class="form-group col-lg-4 col-md-12 col-12">
                            <label><b>Admin Remarks</b><span class="text-danger">*</span></label>
                            <textarea class="form-control" #Remarks="ngModel" ngModel name="Remarks" rows="3"
                                maxlength="300" style="height: 60px;" [(ngModel)]="data.Remarks"></textarea>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <button class="btn btn-success" type="button" id="btnsubmit" (click)="onSubmit(data,1)"
                            style="margin: 5px;">Approve</button>
                        <button class="btn btn-primary" type="button" id="btnreject" (click)="onSubmit(data,2)"
                            style="margin: 5px;">Reject</button>
                        <button class="btn btn-danger" type="button" (click)="redirectToList()"
                            style="margin: 5px;">Cancel</button>
                    </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="footer-login custom-footer">
    <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
    <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
</div>
<ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white;">Please Wait.</p>
</ngx-spinner>
</div>